<template>
  <Select
    :items="arrayStatus"
    :selectedItem="filter.status"
    label="Status"
    searchPlaceholder="Buscar status"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :path="path"
  />
</template>
<script>
import Select from '../../components/Select.vue';
export default {
  components: {
    Select,
  },
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      filter: {
        status: {
          id: "",
          name: "",
        },
      },
      arrayStatus: [
        { id: "F", name: "Finalizado" },
        { id: "A", name: "Aceito" },
        { id: "R", name: "Rejeitado" },
        { id: "C", name: "Cancelado" },
        { id: "DE", name: "Devolvido" },
      ],
    };
  },
  methods: {
    atualizar(status) {
      this.filter.status = status || { id: '', name: '' };

      const valor = this.filter.status.id;
      this.$aplicaFiltroEmURL(this.filtro.filtro, valor, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: valor
      });
    },
  },
  mounted() {
    const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
    this.$renderFiltroSelect(filtroAplicado, this.arrayStatus, this.filter.status);
  },
}
</script>
